import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Team.css';

const teamMembers = [
  {
    name: 'Animesh Sinha',
    handle: '@animesh',
    title: 'Founder',
    photo: '/team-animesh.jpg',
    links: {
      linkedin: 'https://www.linkedin.com/in/animeshsinha1309',
      website: 'https://animesh.bayesmech.com',
      email: 'mailto:animesh@bayesmech.com',
      twitter: 'https://x.com/AnimeshSinha13',
      scholar: 'https://scholar.google.com/citations?user=OMcthakAAAAJ&hl=en'
    },
    color: '#fef08a' // Light yellow matching theme
  },
  {
    name: 'Bhuvanesh Sridharan',
    handle: '@bhuvanesh',
    title: 'Founder',
    photo: '/team-bhuvanesh.jpg',
    links: {
      linkedin: 'https://www.linkedin.com/in/bhuvanesh-sridharan-40887b19b/',
      website: 'https://bhuvanesh.bayesmech.com',
      email: 'mailto:bhuvanesh@bayesmech.com',
      twitter: 'https://x.com/_bhuvanesh_',
      scholar: 'https://scholar.google.com/citations?user=Yy5C2PQAAAA&hl=en'
    },
    color: '#bfdbfe' // Light blue matching theme
  }
];

export default function Team() {
  const [fireDialogs, setFireDialogs] = useState({});
  const [firedMembers, setFiredMembers] = useState({});

  const triggerFire = (idx) => setFireDialogs(prev => ({ ...prev, [idx]: true }));
  const cancelFire = (idx) => setFireDialogs(prev => ({ ...prev, [idx]: false }));
  const confirmFire = (idx) => {
    setFiredMembers(prev => ({ ...prev, [idx]: true }));
    setFireDialogs(prev => ({ ...prev, [idx]: false }));
  };

  return (
    <section className="team-section" id="team">
      <div className="team__header">
        <h2 className="team__heading">Our Team</h2>
        <p className="team__subheading">The researchers and engineers behind BayesMech.</p>
      </div>

      <div className="team__container">
        {teamMembers.map((member, idx) => (
          <div className="team__card-slot" key={idx}>
            <AnimatePresence>
              {!firedMembers[idx] && (
                <motion.div 
                  className="team__card" 
                  style={{ borderColor: '#1a1a24' }}
                  initial={false}
                  exit={{ scale: 0.8, opacity: 0, y: 30 }}
                  transition={{ type: 'spring', damping: 25, stiffness: 200 }}
                >
                  <div className="team__card-header" style={{ backgroundColor: member.color, borderBottomColor: '#1a1a24' }}>
                    <div className="team__window-dots">
                      <span 
                        className="team__dot" 
                        style={{ backgroundColor: '#f43f5e', cursor: 'pointer' }}
                        onClick={() => triggerFire(idx)}
                        title="Close window"
                      ></span>
                    </div>
                    <div className="team__header-title">{member.handle}</div>
                  </div>
                  
                  <div className="team__card-body" style={{ position: 'relative' }}>
                    
                    <AnimatePresence>
                      {fireDialogs[idx] && (
                        <motion.div 
                          className="team__fire-dialog"
                          initial={{ opacity: 0, scale: 0.9, x: '-50%', y: '-50%' }}
                          animate={{ opacity: 1, scale: 1, x: '-50%', y: '-50%' }}
                          exit={{ opacity: 0, scale: 0.9, x: '-50%', y: '-50%' }}
                        >
                          <p>Are you sure you want to fire {member.name} from BayesMech? That will make him sad :'(.</p>
                          <div className="team__fire-actions">
                            <button onClick={() => confirmFire(idx)} className="team__fire-btn team__fire-btn--yes">Yes</button>
                            <button onClick={() => cancelFire(idx)} className="team__fire-btn">No</button>
                          </div>
                        </motion.div>
                      )}
                    </AnimatePresence>

                    <div className="team__photo-wrapper" style={{ opacity: fireDialogs[idx] ? 0.3 : 1, transition: 'opacity 0.2s' }}>
                      <div className="team__photo-placeholder">
                        {/* Photo area with fallback */}
                        <span className="team__photo-initials">{member.name.split(' ').map(n => n[0]).join('')}</span>
                        <img src={member.photo} alt={`${member.name}`} className="team__photo" />
                      </div>
                    </div>
              
              <div className="team__info">
                <h3 className="team__name">{member.name}</h3>
                <p className="team__title">{member.title}</p>
                
                <div className="team__links">
                  {member.links.website && (
                    <a href={member.links.website} target="_blank" rel="noopener noreferrer" className="team__link-btn">
                      Website
                    </a>
                  )}
                  {member.links.scholar && (
                    <a href={member.links.scholar} target="_blank" rel="noopener noreferrer" className="team__link-btn">
                      Scholar
                    </a>
                  )}
                  {member.links.linkedin && (
                    <a href={member.links.linkedin} target="_blank" rel="noopener noreferrer" className="team__link-btn">
                      LinkedIn
                    </a>
                  )}
                  {member.links.twitter && (
                    <a href={member.links.twitter} target="_blank" rel="noopener noreferrer" className="team__link-btn">
                      Twitter
                    </a>
                  )}
                  {member.links.email && (
                    <a href={member.links.email} className="team__link-btn">
                      Email
                    </a>
                  )}
                </div>
              </div>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
    </section>
  );
}
